var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{staticClass:"min-h-screen bg-white pb-16"},[_c('PrintableInvoice',{attrs:{"invoice":_vm.invoiceData,"account-relation":_vm.accountRelation}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }